import React from 'react'
import { useHistory } from 'react-router-dom';
function LastStep() {
   const terrCondition=true
   const history=useHistory()
   const uptodate=true
  return (
<div className="step1 w-[95%] xxs:p-4 p-6 sm:p-10 sm:w-[500px] mt-10 mb-10 md:w-[600px] rounded-[4px] bg-[#303030] m-auto text-center">
  <h1 className="md:text-xl text-base text-white font-bold">Congratulations</h1>
  <h1 className="md:text-lg text-base text-white mt-6">You’re Officially a Fit Streak Member!</h1>
  <label className="flex items-start mb-4 cursor-default mt-6">
      <input
        type="radio"
        name="gender"
        value="I agree to Fit Streak's Terms & Conditions."
        checked={terrCondition === true}

        className={`hidden peer "}`} 
      />
    <span className={`w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 ${terrCondition===true?"border border-red bg-red":"border-2 border-gray-400 ng-inherite"}`}>
    <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-5 h-3 text-white ${terrCondition === true ? "block" : "hidden"} transition-opacity duration-200`}
            viewBox="0 0 20 20"
            style={{ fill: '#fff' }}
        >
            <g data-name="Group 24954">
                <path
                    data-name="Path 68503"
                    d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                    transform="translate(-4.373 -3.52)"
                />
            </g>
        </svg>
    </span>
      <span className={`ml-5 text-[#bbbbbb] text-left md:text-sm text-xs `}>We’ve sent a welcome email with all the details of your membership. Check 
      your email to find your personalized QR code to access the gym!.</span>
    </label>

    {/* Radio Button: Female */}
    <label className="flex items-start mb-4 cursor-default">
      <input
        type="radio"
        name="gender"
        value="Female"
        checked={uptodate === true}

        className={`hidden peer ${uptodate=== true ?"text-white":"text-[#bbbbbb]"}`} 
      />
    <span className={`w-4 h-4 md:w-5 md:h-5 border-2 border-gray-400 rounded-full flex items-center justify-center transition-all duration-200 ${uptodate===true?"border border-red bg-red":"border-2 border-gray-400 ng-inherite"}`}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={`w-5 h-3 text-white ${uptodate === true ? "block" : "hidden"} transition-opacity duration-200`}
            viewBox="0 0 20 20"
            style={{ fill: '#fff' }}
        >
            <g data-name="Group 24954">
                <path
                    data-name="Path 68503"
                    d="m10.691 19.644-4.885-4.886a1.357 1.357 0 0 1 1.919-1.919l3.933 3.919L21.021 7.4a1.357 1.357 0 0 1 1.919 1.919L12.61 19.644a1.355 1.355 0 0 1-1.919 0z"
                    transform="translate(-4.373 -3.52)"
                />
            </g>
        </svg>
    </span>
      <span className={`ml-5 text-[#bbbbbb] text-left md:text-sm text-xs `}>Simply scan your QR code at the gym entrance on your first visit.</span>
    </label>
    <div className='flex flex-row justify-center item-center space-x-8'>
    <button className={`bg-red border py-2 px-6 xxs:text-[9px] border-none  w-max rounded-[5px] text-white font-bold text-xs sm:text-base mt-10`} onClick={()=>history.push('/')}
    >Go to home </button>   
    <button className={`"bg-inherite border border-[#4e4e4e] py-2 px-6 xxs:text-[9px]   w-max rounded-[5px] text-white font-bold text-xs sm:text-base mt-10`}
    >Resend Email</button>      
    </div>
    </div>

  )
}

export default LastStep
